import { createContext, useContext } from 'react';

export interface EventHistoryFiltersContextState {
  isLoadingEvents: boolean;
  events: string[];
  eventFilters: string[];
  eventTypeFilters: string[];
  isLoadingUserAgents: boolean;
  browsers: string[];
  browserFilters: string[];
  operatingSystems: string[];
  operatingSystemFilters: string[];
  devices: string[];
  deviceFilters: string[];
  userAgentFilters: string[];
  search: string;
  toggleFilterForEvent: (eventName: string) => void;
  toggleFilterForBrowser: (browser: string) => void;
  toggleFilterForOperatingSystem: (operatingSystem: string) => void;
  toggleFilterForDevice: (device: string) => void;
  setSearch: (search: string) => void;
  clearFilters: () => void;
}

export const defaultState: EventHistoryFiltersContextState = {
  isLoadingEvents: false,
  eventFilters: [],
  eventTypeFilters: [],
  events: [],
  isLoadingUserAgents: false,
  browserFilters: [],
  browsers: [],
  operatingSystemFilters: [],
  operatingSystems: [],
  deviceFilters: [],
  devices: [],
  userAgentFilters: [],
  search: '',
  toggleFilterForEvent: () => null,
  toggleFilterForBrowser: () => null,
  toggleFilterForOperatingSystem: () => null,
  toggleFilterForDevice: () => null,
  setSearch: () => null,
  clearFilters: () => null,
};

export const EventHistoryFiltersContext =
  createContext<EventHistoryFiltersContextState>(defaultState);

export const useEventHistoryFiltersContext = () => useContext(EventHistoryFiltersContext);
